module.exports = __webpack_public_path__ + "img/dizuo.6a9957f7.png";